/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useQuery } from "@tanstack/react-query";
import { getArticles } from "./queryFunctions";
import { IArticle, IArticlesByIdAPIParams } from "@/interfaces/Analytics.interface";

export const useGetArticleById = (params: IArticlesByIdAPIParams, options: { enabled: boolean, staleTime: number, onSuccess?: (data: IArticle) => void }) => {
  return useQuery({
    queryKey: ["article", params.id, params.qna_id],
    queryFn: () =>
      getArticles({
        workspaceId: params.workspaceId,
        projectId: params.projectId,
        actionParams: {
          action: "get_article",
          params: [
            {
              name: "article_id",
              value: params.id,
            },
            {
              name: "qna_id",
              value: params.qna_id,
            },
          ],
        },
      }),
    ...options,
  });
};
